module.exports = __webpack_public_path__ + "static/media/biT10.cb669789.png";